import sanitizeHtml from 'sanitize-html';
export const getSanitizedText = (text) => {
    const sanitized = sanitizeHtml(text, {
        allowedTags: ['strong', 'em', 'p', 'u', 'ul', 'li', 'br'],
        allowedAttributes: {},
    });
    return sanitized;
};
